import React, {useState} from 'react';
import {Button, Container, Nav, Navbar, NavDropdown, Modal} from "react-bootstrap";
import logo from "../../Img/ESF_LOGO.png"
import logonew from "../../Img/Engenheiros4IU_LOGO_New.png"
import {useNavigate} from "react-router-dom";
import CartaDePrincipios from './Legal/principios';
import Regulamento from './Legal/regulamento';
import PoliticaDeDados from './Legal/politicadedados';
import {useUserAuth} from "../../context/UserAuthContext";


const Header = () => {

    const navigate = useNavigate();
    const {user, role, logOut} = useUserAuth();

    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);


    const [showModalRegulamento, setShowModalRegulamento] = useState(false);
    const handleShowModalRegulamento = () => setShowModalRegulamento(true);
    const handleCloseModalRegulamento = () => setShowModalRegulamento(false);

    const [showModalPoliticaDados, setShowModalPoliticaDados] = useState(false);
    const handleShowModalPoliticaDados = () => setShowModalPoliticaDados(true);
    const handleCloseModalPoliticaDados = () => setShowModalPoliticaDados(false);

    return (
        <Navbar bg="dark" variant="dark" fixed="top" expand="sm">
            <Container fluid>
                <Navbar.Brand href="/">
                    <img src={logonew} width="130" height="90" alt="Logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbar-collapse" />
                <Navbar.Collapse id="navbar-collapse">
                    <div className="mr-auto d-flex justify-content-center">
                        <Nav>
                            <Nav.Link href="https://www.ordemdosengenheiros.pt/regiao-centro/pt/">Ordem dos Engenheiros Região Centro</Nav.Link>

                            <Nav.Link href="/faqs" >FAQs</Nav.Link>
                            <Nav.Link href="/plataforma">Plataforma</Nav.Link>
                            <Nav.Link href="/sobre">Sobre</Nav.Link>
                            <Nav.Link href="/exemplos">Exemplos de Desafios</Nav.Link>


                           
                            <NavDropdown title="Legal" id="legal-dropdown">
                              
                                <NavDropdown.Item href="javascript:void(0)" onClick={handleShowModalRegulamento}>Regulamento de Funcionamento</NavDropdown.Item>
                                <NavDropdown.Item href="javascript:void(0)" onClick={handleShowModalPoliticaDados}>Politica de Dados</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </div>

                    <div className={"ms-auto d-flex align-items-center gap-2"}>
                        {/* Sem sessão: sem botões no cabeçalho — a homepage (herói) é o
                            ponto de entrada para iniciar sessão e registar.
                            Com sessão: espaço do utilizador + Sair */}
                        {user && (
                            <>
                                {role === "admin" && (
                                    <Button variant="outline-light" type={"button"} onClick={() => navigate("/dashboard")}>
                                        Dashboard
                                    </Button>
                                )}
                                {role === "association" && (
                                    <Button variant="outline-light" type={"button"} onClick={() => navigate("/app/associacao")}>
                                        Portal
                                    </Button>
                                )}
                                {role === "engineer" && (
                                    <Button variant="outline-light" type={"button"} onClick={() => navigate("/app/engenheiro")}>
                                        Portal
                                    </Button>
                                )}
                                <Button variant="outline-danger" type={"button"} onClick={() => logOut()}>
                                    Sair
                                </Button>
                            </>
                        )}
                    </div>

                </Navbar.Collapse>

                <Modal show={showModal} onHide={handleCloseModal} size="lg">
                    <Modal.Header closeButton>
                         <h3><strong>Carta de Princípios</strong></h3> 
                    </Modal.Header>
                    <Modal.Body>
                       <CartaDePrincipios/>
                    </Modal.Body>
                </Modal>

                <Modal show={showModalRegulamento} onHide={handleCloseModalRegulamento} size="lg">
                    <Modal.Header closeButton>
                        <h3><strong>Regulamento de Funcionamento</strong></h3>
                    </Modal.Header>
                    <Modal.Body>
                        <Regulamento/>
                    </Modal.Body>
                </Modal>


                <Modal show={showModalPoliticaDados} onHide={handleCloseModalPoliticaDados} size="lg">
                    <Modal.Header closeButton>
                        <h3><strong>Politica de Dados</strong></h3>
                    </Modal.Header>
                    <Modal.Body>
                        <PoliticaDeDados/>
                    </Modal.Body>
                </Modal>
            </Container>
        </Navbar>
       
    );
};

export default Header;